import React, { useState } from "react";

import classes from './InviteUserForm.module.css';
import DataManager from "../../hooks/DataManager";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";


const SelectRoleForm = ({setUserRole, HandleCloseModal, HandleShowLoadingModal, HandleAddUserSites}) => {

    const [selectedRole, setSelectedRole] = useState(null);
    const dataManager = new DataManager();

    const submitHandler = (event) => {
        event.preventDefault();

        if (!selectedRole) return;

        let liveViewEnabled = 0

        let userRole = "User";
        if (selectedRole === "App manager") {
            userRole = "Manager";
        } else if (selectedRole === "App manager plus") {
            userRole = "Manager";
            liveViewEnabled = 1
        }

        setUserRole(userRole);
        dataManager.setItem('roleSelectedForUserInvite', userRole);
        dataManager.setItem('liveViewEnabledForUser', liveViewEnabled);
        HandleCloseModal();
        HandleShowLoadingModal();
        HandleAddUserSites();
        setSelectedRole(null);
    };

    return (
        <form onSubmit={submitHandler} className={classes["container"]} method="dialog">
            <ul className={classes["inputs-list"]}>
                <li className={classes["input-container"]}>
                    <Dropdown
                        value={selectedRole}
                        onChange={(e) => setSelectedRole(e.value)}
                        options={['App standard user', 'App manager', 'App manager plus']}
                        placeholder="Select Role"
                        className="w-full"
                    />
                </li>
            </ul>
            <br />
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Button className={classes.submitButton} type="submit" label="Add to selected sites" severity="success" icon="pi pi-user-plus" disabled={!selectedRole} />
            </div>
        </form>


    )


}

export default SelectRoleForm;

